angular.module('SpidApp')

.constant('DestinationAdapterConfig', {
  name : 'Destination',
  fields : [
    {
    	local   : 'id_pays',
    	distant : 'id_pays'
    }, {
        local   : 'code_destination',
        distant : 'code_destination'
    }, {
        local   : 'label',
        distant : 'label'
    }, {
        local   : 'updated_at',
        distant : 'updated_at'
    }, {
        local   : 'deleted_at',
        distant : 'deleted_at'
    }
  ]
})
